module.exports = __webpack_public_path__ + "static/media/Bluelab pH Controller Wi-Fi.2073c3a9.webp";